import { motion, useInView, useAnimation } from "framer-motion";
import data from "../data.json";
import { useRef, useEffect } from "react";

const SingleEducation = ({ details }) => {
    return (
        <div className="single-education">
            <p style={{ marginBottom: "0.2rem", fontSize: "25px" }}>{details.name}</p>
            <p style={{ marginTop: "0.1rem", marginBottom: "0rem" }}>{details.branch}</p>
            <p style={{ marginTop: "0.1rem", marginBottom: "0.5rem" }}>{details.time}</p>
            <p style={{ marginTop: "0.1rem", fontSize: "17px" }}>{details.result}</p>
        </div>

    );
}

const Education = ({ refEducation }) => {
    const ref = useRef(null);
    const isInView = useInView(ref)
    const mainControlls = useAnimation();
    useEffect(() => {
        if (isInView) {
            mainControlls.start("visible")
        }
        else {
            mainControlls.start("hidden")
        }

    }, [isInView,mainControlls])

    return (
        <div className="item" ref={refEducation}>
            <div ref={ref}>

                <motion.div className="projects-motion" variants={{
                    hidden: { opacity: 0, x: -100 },
                    visible: { opacity: 1, x: 0 }
                }}
                    initial="hidden"
                    animate={mainControlls}
                    transition={{ duration: 0.5, delay: 0.1 }}
                    whileHover={{ scale: 1 }}>
                    <div className="item-title">Education</div>
                    <div className="projects-item" style={{ display: "flex" }}>
                        <div>
                            {data.Education.map((edu) => {
                                return <SingleEducation details={edu} />
                            })}
                        </div>
                        <div style={{ marginLeft: "5rem" }}>
                            <img src="education.png" alt="education img" style={{ height: "450px" }}></img>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    )
}

export default Education;